// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__20qCO","inner":"Footer_inner__1I3ka","nextIcon":"Footer_nextIcon__3z6EG","innerLeft":"Footer_innerLeft__2O4XL"};